import _get from 'lodash/get'

export class MyRoleInfoRecord {
  constructor (record) {
    this._record = record

    this.id = _get(record, 'id', '')
    this.type = _get(record, 'type', '')
    this.permissions = _get(record, 'permissions', '')
  }
}
